import { sendPick } from '@/lib/klaviyo';
import { Field, inputCls, Status, useKForm } from './forms';
import { Reveal } from './Reveal';

export default function WhosNext() {
  const { msg, setMsg } = useKForm();

  const handleSubmit = (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    const trap = form.querySelector('[name=website]');
    if (trap && trap.value) return;
    setMsg({ kind: 'idle', text: '' });
    if (form.pick.value.trim().length < 2) {
      setMsg({ kind: 'err', text: 'Tell us who you want in the car.' });
      return;
    }
    const btn = form.querySelector('[type=submit]');
    const label = btn.textContent;
    btn.disabled = true;
    sendPick(form.pick.value.trim().slice(0, 1000), '')
      .then(() => {
        form.reset();
        setMsg({ kind: 'ok', text: "Got it. Nyah will see your pick." });
      })
      .catch(() => setMsg({ kind: 'err', text: "That didn't go through. Please try again in a moment." }))
      .finally(() => {
        btn.disabled = false;
        btn.textContent = label;
      });
  };

  return (
    <section id="next" className="mx-auto max-w-[1280px] scroll-mt-24 px-6 pt-24 md:pt-32" data-testid="whosnext-section">
      <div className="grid grid-cols-1 items-start gap-12 lg:grid-cols-12">
        <Reveal className="lg:col-span-5">
          <div className="flex flex-col items-start gap-5">
            <h2 className="font-display text-5xl uppercase leading-[0.95] text-ivory md:text-7xl">
              WHO DO YOU <span className="text-mauve">WANT NEXT?</span>
            </h2>
            <p className="max-w-[420px] text-lg text-ivory/70">
              You told us Crazy Cousinz, and they got in the car. Tell Nyah who she should pick up
              next — just drop their Instagram.
            </p>
          </div>
        </Reveal>

        <Reveal delay={0.12} className="lg:col-span-7">
          <form className="flex flex-col gap-4" noValidate onSubmit={handleSubmit} data-testid="whosnext-form">
            <Field label="Who should get in the car next?" htmlFor="next-who">
              <input
                id="next-who"
                name="pick"
                type="text"
                required
                placeholder="Drop their Instagram handle…"
                className={inputCls}
                data-testid="whosnext-pick-input"
              />
            </Field>
            <div className="absolute left-[-9999px] h-px w-px overflow-hidden" aria-hidden="true">
              <label htmlFor="next-web">Leave this empty</label>
              <input id="next-web" name="website" tabIndex={-1} autoComplete="off" />
            </div>
            <button
              type="submit"
              data-testid="whosnext-submit"
              className="mt-2 self-start rounded-full bg-mauve px-8 py-4 font-extrabold text-plum transition-transform duration-200 hover:scale-[1.03] hover:shadow-[0_0_36px_rgba(211,166,207,0.45)] disabled:opacity-60"
            >
              Send my pick
            </button>
            <Status msg={msg} />
          </form>
        </Reveal>
      </div>
    </section>
  );
}
